var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"letter-container"},_vm._l((_vm.letterList),function(item,index){return _c('li',{key:item,staticClass:"letter",class:{ 'active-letter': _vm.activeIndex === index},on:{"click":function($event){return _vm.handleLetterNav(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }